var ADOLOPMENT_OPTIONS, AGE, ALL_COUNTRIES, ALL_LANGUAGES, AdditionalResources, BOOLEAN_OPTIONS, BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE, COUNTRIES, FIELDS, FOCUS, GRADEBOOK_CHAPTERS, GRADE_HANDBOOK_ADDITIONAL_MATERIALS, GRADE_HANDBOOK_FIELDS, GRADING_OPTIONS, INTENDED_POPULATIONS, INTERVENTION_TYPES, LANGUAGES, PCC_MODULES, PLUS, PROGRESS, RECOMMENDATION_INTENTS, RECOMMENDATION_INTENTS_WHO, RECOMMENDATION_STRENGTHS, SECOND_WORLD_REGION_OPTIONS, SYMPTOMS, TYPES_OF_ORGANIZATION, VACCINATION, VERSION_OPTIONS, WORLD_REGIONS;

AdditionalResources = require('components/covid_extraction_form/additional_materials_field');

ALL_COUNTRIES = require('data/countries');

ALL_LANGUAGES = require('data/languages');

TYPES_OF_ORGANIZATION = _.map(['nonProfit', 'governmental', 'academic', 'guidelineSociety', 'intergovernmental'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.typeOfOrganization." + value)
  };
});

BOOLEAN_OPTIONS = [
  {
    value: true,
    textKey: 'yes'
  }, {
    value: false,
    textKey: 'no'
  }
];

GRADING_OPTIONS = [
  {
    value: 'notGraded',
    textKey: 'notGraded'
  }, {
    value: 'grade',
    textKey: 'grade'
  }
];

BOOLEAN_OPTIONS_WITH_NOT_REPORTED = [
  {
    value: true,
    textKey: 'yes'
  }, {
    value: false,
    textKey: 'no'
  }, {
    value: 'notReported',
    textKey: 'notReported'
  }
];

VERSION_OPTIONS = [
  {
    value: 'prePrint',
    textKey: 'draft'
  }, {
    value: 'final',
    textKey: 'final'
  }
];

PROGRESS = _.map(['placeOfResidence', 'raceEthnicityCultureOrLanguage', 'occupation', 'genderOrSex', 'religion', 'education', 'ses', 'socialCapital'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.progress." + value)
  };
});

AGE = _.map(["any", "neonate", "infant", "child", "adolescent", "adult"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.age." + value)
  };
});

PLUS = _.map(['personalCharacteristics', 'featuresOfRelationships', 'timeDependentRelationships'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.plus." + value)
  };
});

FIELDS = _.map(['clinicalPractice', 'hta', 'publicHealth', 'healthPolicyAndSystems'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.field." + value)
  };
});

FOCUS = _.map(['infectionPreventionAndControl', 'screeningAndDiagnosis', 'therapeuticsAndClinicalManagement', 'epidemiologyAndTransmission', 'travel', 'emergencyPreparedness', 'healthServicesAndSystem', 'basicScience'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.focus." + value)
  };
});

WORLD_REGIONS = _.map(['world', 'eastAsiaPacific', 'europeCentralAsia', 'latinAmericaCaribbean', 'middleEastNorthAfrica', 'northAmerica', 'southAsia', 'subSaharanAfrica'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.worldRegion." + value)
  };
});

SECOND_WORLD_REGION_OPTIONS = _.map(['global', 'afro', 'amro_paho', 'emro', 'euro', 'searo', 'wipro', 'missing'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.secondWorldRegionCategory." + value)
  };
});

COUNTRIES = _.map(ALL_COUNTRIES, function(value) {
  return {
    value: value,
    text: $.t("countries:" + value)
  };
});

LANGUAGES = _.map(ALL_LANGUAGES, function(value) {
  return {
    value: value,
    text: $.t("languages:" + value)
  };
});

GRADEBOOK_CHAPTERS = _.map(['introduction', 'makingAnswerableQuestions', 'assessingTheCertaintyOfTheEvidenceAboutEffects', 'assessingTheCertaintyOfTheEvidenceOfTestsAccuracy', 'assessingTheCertaintyOfTheEvidenceOfPrognosisAndBaselineRisk', 'multipleComparisonsAndNma', 'fromEvidenceToDecision', 'fromEvidenceToDecisionOnDiagnosticTests', 'presentationDisseminationAndImplementation', 'theGradeToolKit', 'adolopment', 'livingGuidelines', 'usingOfGradeInSpecialtyAreas'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.gradebookChapters." + value)
  };
});

GRADE_HANDBOOK_FIELDS = [
  {
    fieldKey: 'gradebookChapter',
    type: 'select',
    options: GRADEBOOK_CHAPTERS
  }, {
    fieldKey: 'oldGradebookLink',
    type: 'text',
    placeholderFromI18n: true
  }
];

GRADE_HANDBOOK_ADDITIONAL_MATERIALS = [
  {
    fieldKey: 'linksAndVideos',
    type: 'custom',
    customWithArray: true,
    component: AdditionalResources,
    showClear: false
  }
];

RECOMMENDATION_INTENTS = _.map(['infectionControl', 'vaccination', 'screening', 'diagnosis', 'treatmentAndRehabilitation', 'prognosis', 'planningAndMonitoring', 'healthServicesAndSystems'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.recommendationIntent." + value)
  };
});

RECOMMENDATION_INTENTS_WHO = _.map(['infectionPreventionControl', 'vaccination', 'screening', 'diagnosis', 'clinicalManagement', 'prognosis', 'emergencyPreparedness', 'healthSystemsAndService'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.recommendationIntentWHO." + value)
  };
});

INTENDED_POPULATIONS = _.map(['healthcareWorkers', 'publicHealthOrganizations', 'hospitals', 'educationalInstitutions', 'patientsOrPublic', 'governments', 'humanitarianOrganizations'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.intendedPopulation." + value)
  };
});

CERTAINTIES_OF_EVIDENCE = _.map(['very_low', 'very_low_to_low', 'low', 'low_to_moderate', 'moderate', 'moderate_to_high', 'high', 'other', 'missing'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.certainties." + value)
  };
});

RECOMMENDATION_STRENGTHS = _.map(['recommend_against', 'suggest_against', 'suggest_either', 'suggest', 'recommend', 'other', 'missing'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.strengthOfRecommendation." + value)
  };
});

SYMPTOMS = _.map(['respiratory', 'musculoskeletal', 'cognitive', 'fatigue', 'chest_pain', 'other', 'not_applicable'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.symptoms." + value)
  };
});

VACCINATION = _.map(['fully_vaccinated', 'partially_vaccinated', 'unvaccinated', 'not_reported'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.vaccination." + value)
  };
});

INTERVENTION_TYPES = _.map(['pharmacological', 'non_pharmacological', 'psychosocial'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.intervention_types." + value)
  };
});

ADOLOPMENT_OPTIONS = _.map(['adapted', 'adopted', 'de_novo'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.adolopment." + value)
  };
});

PCC_MODULES = _.map(["prevention", "testing", "clinical_interventions", "neurological_and_psychiatric_topics", "pediatric_and_adolescent_topics", "health_care_services_and_systems"], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.pccModule." + value)
  };
});

module.exports = {
  ADOLOPMENT_OPTIONS: ADOLOPMENT_OPTIONS,
  AGE: AGE,
  BOOLEAN_OPTIONS: BOOLEAN_OPTIONS,
  BOOLEAN_OPTIONS_WITH_NOT_REPORTED: BOOLEAN_OPTIONS_WITH_NOT_REPORTED,
  CERTAINTIES_OF_EVIDENCE: CERTAINTIES_OF_EVIDENCE,
  COUNTRIES: COUNTRIES,
  FIELDS: FIELDS,
  FOCUS: FOCUS,
  GRADE_HANDBOOK_ADDITIONAL_MATERIALS: GRADE_HANDBOOK_ADDITIONAL_MATERIALS,
  GRADE_HANDBOOK_FIELDS: GRADE_HANDBOOK_FIELDS,
  GRADEBOOK_CHAPTERS: GRADEBOOK_CHAPTERS,
  GRADING_OPTIONS: GRADING_OPTIONS,
  INTENDED_POPULATIONS: INTENDED_POPULATIONS,
  INTERVENTION_TYPES: INTERVENTION_TYPES,
  LANGUAGES: LANGUAGES,
  PCC_MODULES: PCC_MODULES,
  PLUS: PLUS,
  PROGRESS: PROGRESS,
  RECOMMENDATION_INTENTS: RECOMMENDATION_INTENTS,
  RECOMMENDATION_INTENTS_WHO: RECOMMENDATION_INTENTS_WHO,
  RECOMMENDATION_STRENGTHS: RECOMMENDATION_STRENGTHS,
  SECOND_WORLD_REGION_OPTIONS: SECOND_WORLD_REGION_OPTIONS,
  SYMPTOMS: SYMPTOMS,
  TYPES_OF_ORGANIZATION: TYPES_OF_ORGANIZATION,
  VACCINATION: VACCINATION,
  VERSION_OPTIONS: VERSION_OPTIONS,
  WORLD_REGIONS: WORLD_REGIONS
};
